import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { clientService } from '@/services/client-service';
import type { AgentFleetView } from '@/types/core/client';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { clientQueryKeys } from './query-keys';

const PRESENCE_REFETCH_MS = 30 * 1000;

/**
 * Live agent presence for a tenant. Polls so liveness stays current without
 * a manual refresh. While `settled` is false an empty agent list means
 * "unknown", not "no agents" — render those states differently.
 */
export function useClientPresence(
  tenantId: UUID | undefined
): UseQueryResult<AgentFleetView, Error> {
  return useQuery<AgentFleetView, Error>({
    queryKey: clientQueryKeys.presence(tenantId),
    queryFn: () => clientService.listClientPresence(tenantId!),
    // useCurrentTenantID() returns the nil UUID (which is truthy) while the tenant
    // is still resolving, so guard on isEmptyUUID like the sibling client hooks —
    // otherwise this fires against the nil tenant on a cold page load.
    enabled: !isEmptyUUID(tenantId),
    refetchInterval: PRESENCE_REFETCH_MS,
  });
}
